export default "__VITE_ASSET__8d006c52__"